module.exports = __webpack_public_path__ + "img/dgitem1.ad9c0e40.png";